import "./Map.css";

const Map = ()=>{
    return(
        <>
        <div className="mapPage">
            <iframe className="MapEdit" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2956.0656602711983!2d83.98526962636724!3d28.226316314586516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2c5b317d2cbab1c3%3A0xbc47198f10fd7c98!2sScaleup%20Academy!5e0!3m2!1sen!2snp!4v1758380544759!5m2!1sen!2snp"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        </>
    )
}
export default Map;